import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const DEFAULT_FAQS = [
  { q: "מהי Mom3ntum?", a: "Mom3ntum היא קהילת מעריצים גלובלית ששמה סוף לעידן הספסרים. אנחנו משתמשים בכוח הקנייה המשותף של הקהילה כדי לשריין מראש כרטיסים לאירועי הענק בעולם — מונדיאל, פורמולה 1, והופעות בינלאומיות. הגישה הזו מאפשרת לחברים שלנו לרכוש כרטיסים נחשקים נטו במחיר העלות המקורי (Face Value), בלי עמלות מנופחות ובלי קומבינות. (ושלא יעבדו עליכם:)" },
  { q: "מה הסיכוי שלי לזכות?", a: "כל מי שנרשם, מצטרף לטלגרם, ועוקב אחרינו ברשתות — נכנס אוטומטית לאתגר. ככל שתבצעו יותר פעולות, כך הסיכוי שלכם גדל. הזוכים יוכרזו ב-31.3.2026." },
  { q: "האם ההרשמה באמת חינמית?", a: "כן לחלוטין. אין עלות הרשמה, אין התחייבות, ואין כרטיס אשראי. הכל חינם." },
  { q: "מה כולל הפרס הגדול?", a: "זוג כרטיסים למשחק הפתיחה של גביע העולם 2026 — USA/Paraguay, CAT 1 Seating. הטיסות וההגעה דרך קשרי תעופה בנפרד." },
  { q: "מתי נדע מי זכה?", a: "הכרזת הזוכים תתבצע ב-31.3.2026 דרך ערוץ הטלגרם של Mom3ntum ובאימייל אישי לזוכים." },
  { q: "אני כבר חבר בקהילה — האם אני זכאי להשתתף?", a: "בהחלט! חברים קיימים שנרשמים דרך הטופס ועומדים בתנאים — נכנסים אוטומטית לאתגר." },
];

export default function FAQSection({ config }) {
  const faqs = config?.items ?? DEFAULT_FAQS;
  const [open, setOpen] = useState(null);

  return (
    <section dir="rtl" style={{ background: "linear-gradient(180deg, #161616 0%, #252525 100%)", padding: "80px 16px" }}>
      <div className="max-w-2xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#c8f135" }}>שאלות נפוצות</p>
          <h2 className="font-black mb-2 text-white" style={{ fontSize: "clamp(1.8rem, 4vw, 2.6rem)" }}>יש לכם שאלות?</h2>
          <p className="text-sm font-semibold" style={{ color: "rgba(255,255,255,0.35)" }}>הנה מה שהרבה שאלו</p>
        </motion.div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="rounded-2xl overflow-hidden"
              style={{
                border: open === i ? "1.5px solid rgba(200,241,53,0.4)" : "1.5px solid #1f1f1f",
                background: "#111",
                transition: "border-color 0.2s",
              }}
            >
              <button
                className="w-full flex items-center justify-between p-5 text-right"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="font-bold text-sm text-white">{faq.q}</span>
                <ChevronDown
                  className="w-4 h-4 flex-shrink-0 ml-3 transition-transform duration-200"
                  style={{ color: "#c8f135", transform: open === i ? "rotate(180deg)" : "rotate(0deg)" }}
                />
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <p className="px-5 pb-5 pt-3 text-sm leading-relaxed" style={{ color: "rgba(255,255,255,0.75)", borderTop: "1px solid #1a1a1a" }}>
                      {faq.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}